import { createSlice, createSelector } from "@reduxjs/toolkit";
import { apiCallBegan } from "./api";
import config from "../../config.json";

const slice = createSlice({
    name: "subForm",
    initialState: {
        list: [],
        loading: false,
        lastFetch: null,
        subFormBprmForm: null
    },
    reducers: {
        subFormBprmFormReceived: (subForm, action) => {
            subForm.subFormBprmForm = action.payload;
        },
    }
});

export const { subFormBprmFormReceived } = slice.actions;
export default slice.reducer;

export const loadSubFormBprmForm = (id) => apiCallBegan({
    url: config.GetForm + id,
    onSuccess: subFormBprmFormReceived.type
});

export const getSubFormBprmForm = createSelector(
    state => state.entities.subForm,
    subForm => subForm.subFormBprmForm
);
